// extracted by mini-css-extract-plugin
export var table = "_tk-0";